export const content = {
    domain: "Advance Financial",
    footer: "advanefinance.com",
    title1: "Quick Loan Offer $100-$5,000",
  };
  